import React from "react";
import type { MetricSource } from "../../../../../shared/metrics";
import { pageDescription } from "../../../lib/metrics-display";

export function MetricsPageHead({
  anchor,
  sources,
}: {
  anchor: string;
  sources: MetricSource[];
}) {
  return (
    <div>
      <h1 className="font-sans text-heading font-bold leading-tight text-foreground">
        Metrics
      </h1>
      <p className="mt-1 max-w-[620px] text-sm leading-[1.5] text-muted-strong">
        {pageDescription(anchor, sources)}
      </p>
    </div>
  );
}
